// 签收
export default [
    //换货包裹跟进
    {
        path: '/exchangeList',
        name: 'exchangeList',
        component: () => import( /* webpackChunkName: "returnAndExchangeLogistics" */ '@/views/home/returnAndExchangeLogistics/exchangeList'),
        meta: {
            activeMenu: 'exchangeList', // 可用选中菜单
            // keepAlive: true // true 开启。
        }
    },
    //待打印面单
    {
        path: '/printFaceSheet',
        name: 'printFaceSheet',
        component: () => import( /* webpackChunkName: "returnAndExchangeLogistics" */ '@/views/home/returnAndExchangeLogistics/printFaceSheet'),
        meta: {
            activeMenu: 'printFaceSheet', // 可用选中菜单
            // keepAlive: true // true 开启。
        }
    },
    //退货待扫描
    {
        path: '/returnScan',
        name: 'returnScan',
        component: () => import( /* webpackChunkName: "returnAndExchangeLogistics" */ '@/views/home/returnAndExchangeLogistics/returnScan'),
        meta: {
            activeMenu: 'returnScan', // 可用选中菜单
            // keepAlive: true // true 开启。
        }
    },
    //签收已扫描
    {
        path: '/signInScan',
        name: 'signInScan',
        component: () => import( /* webpackChunkName: "returnAndExchangeLogistics" */ '@/views/home/returnAndExchangeLogistics/signInScan'),
        meta: {
            activeMenu: 'signInScan', // 可用选中菜单
            // keepAlive: true // true 开启。
        }
    },
    //待打包
    {
        path: '/toBePacked',
        name: 'toBePacked',
        component: () => import( /* webpackChunkName: "returnAndExchangeLogistics" */ '@/views/home/returnAndExchangeLogistics/toBePacked'),
        meta: {
            activeMenu: 'toBePacked', // 可用选中菜单
            // keepAlive: true // true 开启。
        }
    },

    // 包裹扫描

    // 收货
    {
        path: '/receipt',
        name: 'receipt',
        component: () => import( /* webpackChunkName: "scanningParcel" */ '@/views/home/scanningParcel/receipt'),
        meta: {
            activeMenu: 'receipt', // 可用选中菜单
        }
    },
    // 国内退件扫描
    {
        path: '/domesticReturnScan',
        name: 'domesticReturnScan',
        component: () => import( /* webpackChunkName: "scanningParcel" */ '@/views/home/scanningParcel/domesticReturnScan'),
        meta: {
            activeMenu: 'domesticReturnScan', // 可用选中菜单
        }
    },
    // 待签收
    {
        path: '/toBeSigned',
        name: 'toBeSigned',
        component: () => import( /* webpackChunkName: "emergencyItems" */ '@/views/home/emergencyItems/toBeSigned'),
        meta: {
            activeMenu: 'toBeSigned', // 可用选中菜单
        }
    },
    // 已签收
    {
        path: '/signedAndReceived',
        name: 'signedAndReceived',
        component: () => import( /* webpackChunkName: "emergencyItems" */ '@/views/home/emergencyItems/signedAndReceived'),
        meta: {
            activeMenu: 'signedAndReceived', // 可用选中菜单
        }
    },
    // 待线下提货
    {
        path: '/offlineDelivery',
        name: 'offlineDelivery',
        component: () => import( /* webpackChunkName: "logisticsAndFreightFollowUp" */ '@/views/home/logisticsAndFreightFollow-up/offlineDelivery'),
        meta: {
            activeMenu: 'offlineDelivery', // 可用选中菜单
        }
    },
    // 已提货待确认
    {
        path: '/deliveryToBeConfirmed',
        name: 'deliveryToBeConfirmed',
        component: () => import( /* webpackChunkName: "logisticsAndFreightFollowUp" */ '@/views/home/logisticsAndFreightFollow-up/deliveryToBeConfirmed'),
        meta: {
            activeMenu: 'deliveryToBeConfirmed', // 可用选中菜单
        }
    },
    // 提货已确认
    {
        path: '/deliveryConfirm',
        name: 'deliveryConfirm',
        component: () => import( /* webpackChunkName: "logisticsAndFreightFollowUp" */ '@/views/home/logisticsAndFreightFollow-up/deliveryConfirm'),
        meta: {
            activeMenu: 'deliveryConfirm', // 可用选中菜单
        }
    },
    // 待认领包裹
    {
        path: '/waitingToBeClaimed',
        name: 'waitingToBeClaimed',
        component: () => import( /* webpackChunkName: "claimAParcel" */ '@/views/home/claimAParcel/waitingToBeClaimed'),
        meta: {
            activeMenu: 'waitingToBeClaimed', // 可用选中菜单
        }
    },
    // 已认领包裹
    {
        path: '/haveBeenClaimed',
        name: 'haveBeenClaimed',
        component: () => import( /* webpackChunkName: "claimAParcel" */ '@/views/home/claimAParcel/haveBeenClaimed'),
        meta: {
            activeMenu: 'haveBeenClaimed', // 可用选中菜单
        }
    },


    // scanningParcel


]